import React, { Fragment, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import Scrollbar from "../scrollbar/scrollbar";

const OrderFailedSec = ({ carts, token, ...props }) => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [loading] = useState(false);

  const reasons = [
    "Card was declined by your bank or 3D-Secure failed",
    "Insufficient balance or daily transaction limit reached",
    "Incorrect billing details (name, address, postcode)",
    "Network interruption during the payment flow",
  ];

  return (
    <Fragment>
      <Navbar />

      <section className="gpfail-section">
        <div className="gpfail-bg-orb gpfail-bg-orb-tl" />
        <div className="gpfail-bg-orb gpfail-bg-orb-br" />

        <div className="gpfail-inner">
          {loading ? (
            <div className="gpfail-card gpfail-skeleton">
              <div className="gpfail-sk-icon" />
              <div className="gpfail-sk-line gpfail-sk-line-lg" />
              <div className="gpfail-sk-line gpfail-sk-line-md" />
              <div className="gpfail-sk-line gpfail-sk-line-sm" />
            </div>
          ) : (
            <>
              <div className="gpfail-card">
                <div className="gpfail-icon-wrap">
                  <div className="gpfail-icon-ring" />
                  <div className="gpfail-icon-ring gpfail-icon-ring-2" />
                  <div className="gpfail-icon">
                    <svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <line x1="6" y1="6" x2="18" y2="18" />
                      <line x1="18" y1="6" x2="6" y2="18" />
                    </svg>
                  </div>
                </div>

                <div className="gpfail-eyebrow">
                  <span className="gpfail-eyebrow-dot" />
                  PAYMENT FAILED
                </div>

                <h1 className="gpfail-title">
                  Your order <span className="gpfail-title-accent">couldn't be placed</span>
                </h1>
                <p className="gpfail-sub">
                  We couldn't complete your payment. No amount has been charged to your card. You can try again or use a different payment method.
                </p>

                {orderId && (
                  <div className="gpfail-order-ref">
                    <span className="gpfail-order-ref-label">Reference</span>
                    <span className="gpfail-order-ref-id">{orderId}</span>
                  </div>
                )}

                <div className="gpfail-actions">
                  <button
                    type="button"
                    className="gpfail-btn gpfail-btn-primary"
                    onClick={() => navigate("/checkout")}
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23 4 23 10 17 10" />
                      <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
                    </svg>
                    Try Payment Again
                  </button>
                  <Link to="/" className="gpfail-btn gpfail-btn-ghost">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 12l9-9 9 9" />
                      <path d="M5 10v10h14V10" />
                    </svg>
                    Back to Home
                  </Link>
                </div>
              </div>

              <div className="gpfail-secondary">
                <div className="gpfail-reasons">
                  <h3>Common reasons</h3>
                  <ul>
                    {reasons.map((r, i) => (
                      <li key={i}>
                        <span className="gpfail-bullet">
                          <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                          </svg>
                        </span>
                        {r}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="gpfail-support">
                  <div className="gpfail-support-icon">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                      <path d="M20.52 3.48A11.94 11.94 0 0012.06 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.34-1.66a11.85 11.85 0 005.71 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.45zM12.06 21.7h-.01a9.85 9.85 0 01-5.02-1.37l-.36-.21-3.76.98 1-3.66-.23-.38a9.83 9.83 0 01-1.51-5.2c0-5.45 4.43-9.88 9.88-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 012.89 6.99c0 5.45-4.43 9.83-9.87 9.83z" />
                    </svg>
                  </div>
                  <div className="gpfail-support-body">
                    <h4>Need help?</h4>
                    <p>Our team is one tap away — we'll help resolve it within minutes.</p>
                    <a
                      href="https://wa.me/971545740174?text=Hello%20GlobalGiftPass%2C%20my%20payment%20failed%20and%20I%20need%20assistance."
                      target="_blank"
                      rel="noreferrer"
                      className="gpfail-wa-btn"
                    >
                      Chat on WhatsApp
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <style>{`
          .gpfail-section {
            position: relative;
            background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
            color: #e6e8ec;
            padding: 70px 22px 90px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            overflow: hidden;
            min-height: 100vh;
            display: flex;
            align-items: center;
          }
          .gpfail-bg-orb {
            position: absolute;
            width: 460px;
            height: 460px;
            border-radius: 50%;
            filter: blur(140px);
            opacity: 0.4;
            pointer-events: none;
          }
          .gpfail-bg-orb-tl { background: rgba(255, 90, 90, 0.18); top: -180px; left: -120px; }
          .gpfail-bg-orb-br { background: rgba(212,168,87,0.14); bottom: -200px; right: -120px; }

          .gpfail-inner {
            position: relative;
            max-width: 720px;
            width: 100%;
            margin: 0 auto;
            z-index: 1;
          }

          /* MAIN CARD */
          .gpfail-card {
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.22);
            border-radius: 22px;
            padding: 50px 36px 40px;
            text-align: center;
            box-shadow: 0 18px 40px rgba(0,0,0,0.4);
          }

          .gpfail-icon-wrap {
            position: relative;
            width: 110px;
            height: 110px;
            margin: 0 auto 22px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .gpfail-icon-ring {
            position: absolute;
            inset: 0;
            border-radius: 50%;
            border: 2px solid rgba(255, 90, 90, 0.25);
            animation: gpfail-ring 2.4s ease-out infinite;
          }
          .gpfail-icon-ring-2 { animation-delay: 1.2s; }
          @keyframes gpfail-ring {
            0% { transform: scale(0.85); opacity: 0.85; }
            100% { transform: scale(1.4); opacity: 0; }
          }
          .gpfail-icon {
            position: relative;
            width: 84px;
            height: 84px;
            border-radius: 50%;
            background: linear-gradient(135deg, #ff6b6b, #c0392b);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 12px 28px rgba(192, 57, 43, 0.45), inset 0 -4px 12px rgba(0,0,0,0.25);
            animation: gpfail-shake 0.6s ease-out 0.2s both;
          }
          @keyframes gpfail-shake {
            0%, 100% { transform: translateX(0); }
            20% { transform: translateX(-4px); }
            40% { transform: translateX(4px); }
            60% { transform: translateX(-3px); }
            80% { transform: translateX(3px); }
          }

          .gpfail-eyebrow {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 6px 14px;
            background: rgba(255, 90, 90, 0.1);
            border: 1px solid rgba(255, 90, 90, 0.3);
            color: #ff7a7a;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 2px;
            margin-bottom: 14px;
          }
          .gpfail-eyebrow-dot {
            width: 6px; height: 6px; border-radius: 50%;
            background: #ff7a7a;
            box-shadow: 0 0 10px #ff7a7a;
            animation: gpfail-pulse 1.6s ease-in-out infinite;
          }
          @keyframes gpfail-pulse {
            0%,100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.55; transform: scale(0.85); }
          }

          .gpfail-title {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 34px;
            color: #fff;
            font-weight: 700;
            margin: 0 0 12px;
            line-height: 1.2;
          }
          .gpfail-title-accent {
            background: linear-gradient(135deg, #ff8a8a, #c0392b);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-style: italic;
            font-weight: 600;
          }
          .gpfail-sub {
            font-size: 14.5px;
            color: #9aa0a8;
            line-height: 1.65;
            max-width: 480px;
            margin: 0 auto 22px;
          }

          .gpfail-order-ref {
            display: inline-flex;
            align-items: center;
            gap: 12px;
            padding: 10px 16px;
            background: rgba(255,255,255,0.03);
            border: 1px dashed rgba(212,168,87,0.25);
            border-radius: 12px;
            margin-bottom: 26px;
          }
          .gpfail-order-ref-label {
            font-size: 11px;
            color: #9aa0a8;
            text-transform: uppercase;
            letter-spacing: 1.4px;
            font-weight: 700;
          }
          .gpfail-order-ref-id {
            font-size: 14px;
            color: #d4a857;
            font-weight: 700;
            font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
          }

          .gpfail-actions {
            display: flex;
            gap: 12px;
            justify-content: center;
            flex-wrap: wrap;
          }
          .gpfail-btn {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 13px 26px;
            border-radius: 12px;
            font-size: 13px;
            font-weight: 800;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            cursor: pointer;
            text-decoration: none;
            border: none;
            transition: transform .2s ease, box-shadow .25s ease, background .2s ease;
          }
          .gpfail-btn-primary {
            background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
            color: #0b0b0c;
          }
          .gpfail-btn-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(212,168,87,0.35);
            color: #0b0b0c;
            text-decoration: none;
          }
          .gpfail-btn-ghost {
            background: rgba(255,255,255,0.03);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
          }
          .gpfail-btn-ghost:hover {
            background: rgba(212,168,87,0.1);
            border-color: rgba(212,168,87,0.55);
            color: #f1cf85;
            text-decoration: none;
            transform: translateY(-2px);
          }

          /* SECONDARY ROW */
          .gpfail-secondary {
            display: grid;
            grid-template-columns: 1.1fr 1fr;
            gap: 16px;
            margin-top: 18px;
          }

          .gpfail-reasons,
          .gpfail-support {
            background: linear-gradient(180deg, rgba(21,17,10,0.85) 0%, rgba(26,18,8,0.85) 100%);
            border: 1px solid rgba(212,168,87,0.18);
            border-radius: 18px;
            padding: 22px;
          }
          .gpfail-reasons h3,
          .gpfail-support-body h4 {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 17px;
            color: #fff;
            margin: 0 0 12px;
            font-weight: 700;
          }
          .gpfail-reasons ul {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .gpfail-reasons li {
            display: flex;
            gap: 10px;
            align-items: flex-start;
            font-size: 13px;
            color: #c5c8cf;
            line-height: 1.55;
          }
          .gpfail-bullet {
            width: 18px;
            height: 18px;
            background: rgba(212,168,87,0.14);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-top: 2px;
          }

          .gpfail-support {
            display: grid;
            grid-template-columns: 44px 1fr;
            gap: 14px;
            align-items: flex-start;
          }
          .gpfail-support-icon {
            width: 44px;
            height: 44px;
            background: linear-gradient(135deg, #25d366, #128c7e);
            color: #fff;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .gpfail-support-body p {
            font-size: 13px;
            color: #9aa0a8;
            line-height: 1.55;
            margin: 0 0 12px;
          }
          .gpfail-wa-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 9px 16px;
            background: linear-gradient(135deg, #25d366, #128c7e);
            color: #fff;
            font-size: 12.5px;
            font-weight: 700;
            border-radius: 10px;
            text-decoration: none;
            transition: transform .2s ease, box-shadow .25s ease, gap .2s ease;
          }
          .gpfail-wa-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 22px rgba(37,211,102,0.3);
            color: #fff;
            text-decoration: none;
            gap: 12px;
          }

          /* SKELETON */
          .gpfail-skeleton { padding: 60px 36px; display: flex; flex-direction: column; align-items: center; gap: 16px; }
          .gpfail-sk-icon { width: 84px; height: 84px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: gpfail-shimmer 1.4s ease infinite; }
          .gpfail-sk-line { height: 14px; border-radius: 7px; background: rgba(255,255,255,0.05); animation: gpfail-shimmer 1.4s ease infinite; }
          .gpfail-sk-line-lg { width: 60%; height: 22px; }
          .gpfail-sk-line-md { width: 80%; }
          .gpfail-sk-line-sm { width: 40%; }
          @keyframes gpfail-shimmer {
            0%,100% { opacity: 0.5; }
            50% { opacity: 1; }
          }

          @media (max-width: 720px) {
            .gpfail-secondary { grid-template-columns: 1fr; }
          }
          @media (max-width: 575px) {
            .gpfail-section { padding: 50px 14px 70px; }
            .gpfail-card { padding: 40px 22px 32px; }
            .gpfail-title { font-size: 26px; }
            .gpfail-actions { flex-direction: column; }
            .gpfail-btn { width: 100%; justify-content: center; }
            .gpfail-icon-wrap { width: 96px; height: 96px; }
            .gpfail-icon { width: 72px; height: 72px; }
          }
        `}</style>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default OrderFailedSec;
